import { config } from "~/data/config";

export const razorpayTDConfig = {
  onlyCardConfigForTD: {
    display: {
      blocks: {
        block1: {
          name: "Pay through Cards",
          instruments: [
            {
              method: "card",
              ...(config.env === "Prod"
                ? { iins: ["652926", "652925", "402219", "402359", "431581"] }
                : {}),
            },
          ],
        },
      },
      sequence: ["block.block1"],
      preferences: {
        show_default_blocks: false,
      },
    },
  },
};
